import { site } from "@/config/site";

// Centralised, easily-editable offer detail for the /onetimecampaignsetup page.
// Leave any value as an empty string to gracefully hide that row publicly.
export const campaignOffer = {
  price: "",                     // e.g. "$1,850 USD (one-time)"
  implementationTimeline: "",    // e.g. "7–10 business days"
  supportPeriod: "",             // e.g. "14 days"
};

// Central booking URL for every campaign-setup CTA. Keep this the single source of truth.
export const CAMPAIGN_SETUP_BOOKING_URL = site.bookingUrl;

export const CAMPAIGN_FORM_META = {
  formName: "One-Time Campaign Setup Enquiry",
  leadSource: "Fortuna Strive – One-Time Campaign Setup",
};

export const businessTypeOptions = [
  "Home Service Business",
  "Consultant or Coach",
  "Local Service Business",
  "Appointment-Based Business",
  "Testing Paid Acquisition",
  "Other",
];

export const currentAdStatusOptions = [
  "Not running ads yet",
  "Ran ads previously — paused",
  "Currently running ads — not performing",
  "Currently running ads — want to restructure",
];

export const monthlyAdBudgetOptions = [
  "Under $500",
  "$500 – $1,500",
  "$1,500 – $5,000",
  "$5,000 – $10,000",
  "$10,000+",
  "Not sure yet",
];
